import { render, staticRenderFns } from "./PortfolioInvestmentItem.vue?vue&type=template&id=69236b26&"
import script from "./PortfolioInvestmentItem.vue?vue&type=script&lang=js&"
export * from "./PortfolioInvestmentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports